var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("这是父组件")]),_vm._v(" "),_c('Son',{scopedSlots:_vm._u([{key:"myslot",fn:function(scope){return [_c('ul',_vm._l((scope.data),function(item){return _c('li',[_vm._v(_vm._s(item))])}),0)]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f913f68c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/demo/index.vue
// module id = null
// module chunks = 